import React from 'react';
import PropTypes from 'prop-types';
import StyledGlobalStyle from './GlobalStyle.style';
GlobalShadowStyle.propTypes = {
  /** normalize css for better cross browser rendering */
  normalize: PropTypes.bool,

  /** set all elements to use box-sizing: border-box */
  borderBox: PropTypes.bool,

  /** Used to set a custom CDN Path to read the fonts from */
  customCDN: PropTypes.shape({
    assetsPath: PropTypes.shape({
      fonts: PropTypes.string.isRequired,
      images: PropTypes.string
    }).isRequired,
    cdnUrl: PropTypes.string.isRequired
  })
};
GlobalShadowStyle.defaultProps = {
  normalize: false,
  borderBox: false
};
export function GlobalShadowStyle(_ref) {
  var normalize = _ref.normalize,
      borderBox = _ref.borderBox,
      customCDN = _ref.customCDN;
  return /*#__PURE__*/React.createElement(StyledGlobalStyle, {
    normalize: normalize,
    borderBox: borderBox,
    customCDN: customCDN
  });
}